import RedirectIfAuthenticated from '@/middleware/RedirectIfAuthenticated'

export default function middleware (router) {
  RedirectIfAuthenticated(router)
}



// WEBPACK FOOTER //
// ./src/middleware.js